import EntityContacts from "../components/right-panel/entity/EntityContacts";
import EntityContracts from "../components/right-panel/entity/EntityContracts";
import EntityEntities from "../components/right-panel/entity/EntityEntities";
import EntityLocations from "../components/right-panel/entity/EntityLocations";
import EntityNotes from "../components/right-panel/entity/EntityNotes";
import EntityPayments from "../components/right-panel/entity/EntityPayments";
import EntityUsers from "../components/right-panel/entity/EntityUsers";

const RIGHT_PANEL_TABS_TEMPLATE = {
  entity: [
    {
      key: "management",
      name: "Management",
      subtabs: [
        {
          key: "contracts",
          name: "Contracts",
          description: "Entity summary content will appear here.",
          component: EntityContracts,
        },
        {
          key: "payments",
          name: "Payments",
          description: "Entity relationship content will appear here.",
          component: EntityPayments,
        },
        {
          key: "notes",
          name: "Internal Notes",
          description: "Entity relationship content will appear here.",
          component: EntityNotes,
        },
      ],
    },
    {
      key: "association",
      name: "Association",
      subtabs: [
        {
          key: "entities",
          name: "Entities",
          description: "",
          component: EntityEntities,
        },
        {
          key: "locations",
          name: "Locations",
          description: "",
          component: EntityLocations,
        },
      ],
    },
    {
      key: "personnel-info",
      name: "Personnel Info",
      subtabs: [
        {
          key: "users",
          name: "Users",
          description: "Entity summary content will appear here.",
          component: EntityUsers,
        },
        {
          key: "contacts",
          name: "Contacts",
          description: "Entity relationship content will appear here.",
          component: EntityContacts,
        },
      ],
    },
  ],
  campaign: [],
  lawfirm: [],
};

export default RIGHT_PANEL_TABS_TEMPLATE;
